import React, { useMemo, useState,useEffect } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import "../../assets/scss/mobile/styleMobile.scss";
import userImg from "../../assets/img/mobileImg/user.png";
import InfiniteScroll from "react-infinite-scroll-component";
import { getSessionDataOnlyRead } from "utils/common";
import { getAvailableBalance,getRangeList,getPayInOutList,showMessage,addFund,withdrawFund} from "store/reducers/common.slice";
export default function MobileViewStatment() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { availableBalance,amountRangeList,whatappRecords,isAddFund,addFundLoading,iswithdrawFund,withdrawFundLoading,payInList,payOutList,totalPayInRecord,totalPayOutRecord,payInOutListLoading} = useSelector(
    ({ common }) => common
  );
  const fetchMoreDataInTable = (type) => {
    return () => {
      if (payInOutListLoading) return; 
      let page = type === "pay-in" ? payInList.length / 10 + 1 : payOutList.length / 10 + 1;
      dispatch(getPayInOutList({ page, payOut: type }));
      };
  };   
  const userName = useMemo(() => {
    let { userName } = getSessionDataOnlyRead();
    return userName
  }, [])
  const [activeTab, setActiveTab] = useState("1");
  useEffect(() => {
      dispatch(getPayInOutList({ page: 1, payOut: 'pay-in' }));
  }, []);
  return (
    <main className="trade_page">
      <header>
        <div className="confirm_order_header">
          <div className="close_icon">
            <span
              className="material-symbols-outlined"
              onClick={() => history.goBack()}
            >
            keyboard_backspace
            </span>{" "}
            <span>View Statement ({userName})</span>
          </div>
        </div>
      </header>
    <div className="orderBook_tabs my-4">
      <Nav
        tabs
        className="nav nav-pills mb-3"
        id="pills-tab"
        role="tablist"
        style={{top: "50px" }}
      >
        <NavItem className="nav-item" role="presentation">
          <NavLink
            className={`nav-link fw-bold ${activeTab === "1" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("1");
              dispatch(getPayInOutList({ page: 1, payOut: "pay-in" }));
            }}
            style={{fontSize: "15px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center", }}
          >
            ADD FUNDS
          </NavLink>
        </NavItem>
        <NavItem className="nav-item" role="presentation">
          <NavLink
            className={`nav-link fw-bold ${activeTab === "2" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("2");
              dispatch(getPayInOutList({ page: 1, payOut: "pay-Out" }));
            }}
             style={{fontSize: "15px", height: "50px", display: "flex", alignItems: "center", justifyContent: "center", }}
          >
            WITHDRAW FUNDS
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <div  className="table-responsive" id="custom_table_observer_1" style={{ maxHeight: "400px", overflowY: "auto" }}>
            <InfiniteScroll
              dataLength={payInList.length}
              next={fetchMoreDataInTable("pay-in")}
              hasMore={payInList.length < totalPayInRecord}
              scrollableTarget="custom_table_observer_1"
            >
              <table className="table-flush table table-medium card_bold">
                <thead className="thead-light">
                  <tr>
                    <th>#</th>
                    <th>Status</th>
                    <th>Amount</th>
                    <th>Date</th>
                    <th>Remark</th>
                    <th>CR/DR</th>
                  </tr>
                </thead>
                <tbody>
                  {payInList.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.statusName}</td>
                      <td>{item.amount}</td>
                      <td>{item.addTime}</td>
                      <td>{item.remark}</td>
                      <td>Credit</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </InfiniteScroll>
          </div>
        </TabPane>

        <TabPane tabId="2">
          <div id="custom_table_observer_2" style={{ maxHeight: "400px", overflowY: "auto" }}>
            <InfiniteScroll
              dataLength={payOutList.length}
              next={fetchMoreDataInTable("pay-Out")}
              hasMore={payOutList.length < totalPayOutRecord}
              scrollableTarget="custom_table_observer_2"
            >
              <table className="table-flush table table-medium card_bold">
                <thead className="thead-light">
                  <tr>
                    <th>#</th>
                    <th>Status</th>
                    <th>Amount</th>
                    <th>Date</th>
                    <th>Remark</th>
                    <th>CR/DR</th>
                  </tr>
                </thead>
                <tbody>
                  {payOutList.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.statusName}</td>
                      <td>{item.amount}</td>
                      <td>{item.addTime}</td>
                      <td>{item.remark}</td>
                      <td>Debit</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </InfiniteScroll>
          </div>
        </TabPane>
      </TabContent>
    </div>

    </main>
  );
}
